import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, Crown, Info } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../lib/constants'; 

const UploadLimitWarning = ({ remainingUploads, todayUploads, maxUploads = 3 }) => {
const { isPremium } = useAuth();
const navigate = useNavigate();

  // Don't show for premium users
  if (isPremium) {
    return null;
  }

  const handleUpgrade = () => {
  console.log("Navigating to:", ROUTES.PRICING); // Check your browser console!
  navigate(ROUTES.PRICING || '/pricing');
};
  // Show different messages based on remaining uploads
  if (remainingUploads === 0) {
    return (
      <div className="backdrop-blur-sm bg-red-50/50 border border-red-200/50 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 animate-fade-in">
        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-3 md:space-x-4">
          <AlertCircle className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-red-600 flex-shrink-0" />
          <div className="flex-1 space-y-2 sm:space-y-3">
            <h4 className="text-sm sm:text-base md:text-lg font-semibold text-red-900">
              Daily upload limit reached
            </h4>
            <p className="text-xs sm:text-sm md:text-base text-red-800 leading-relaxed">
              You've used all {maxUploads} of your free uploads for today. Come back tomorrow or upgrade to Premium for unlimited uploads!
            </p>
            
            {/* CTA Button - Added onClick */}
            <button 
              onClick={handleUpgrade}
              className="inline-flex items-center px-3 sm:px-4 md:px-5 py-2 sm:py-2.5 bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-white text-xs sm:text-sm md:text-base font-semibold rounded-lg sm:rounded-xl transition-all shadow-md hover:shadow-lg mt-2 sm:mt-3"
            >
              <Crown className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
              Upgrade to Premium
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (remainingUploads === 1) {
    return (
      <div className="backdrop-blur-sm bg-yellow-50/50 border border-yellow-200/50 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 animate-fade-in">
        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-3 md:space-x-4">
          <AlertCircle className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-yellow-600 flex-shrink-0" />
          <div className="flex-1 space-y-1 sm:space-y-2">
            <h4 className="text-sm sm:text-base md:text-lg font-semibold text-yellow-900">
              Last upload for today
            </h4>
            <p className="text-xs sm:text-sm md:text-base text-yellow-800 leading-relaxed">
              You have <strong>1 upload remaining</strong> today. <span onClick={handleUpgrade} className="underline cursor-pointer font-bold">Upgrade to Premium</span> for unlimited uploads and more features!
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="backdrop-blur-sm bg-blue-50/50 border border-blue-200/50 rounded-xl sm:rounded-2xl p-3 sm:p-4 md:p-5 animate-fade-in">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-2 sm:space-y-0 gap-2 sm:gap-3">
        <div className="flex items-start sm:items-center space-x-2 sm:space-x-3 flex-1">
          <Info className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 flex-shrink-0 mt-0.5 sm:mt-0" />
          <p className="text-xs sm:text-sm md:text-base text-blue-900">
            <strong className="font-semibold">{remainingUploads} uploads</strong> remaining today 
            <span className="text-blue-700"> ({todayUploads}/{maxUploads} used)</span>
          </p>
        </div>
        
        {/* Upgrade link - Added onClick */}
        <button 
          onClick={handleUpgrade}
          className="text-xs sm:text-sm md:text-base text-blue-700 hover:text-blue-900 font-semibold whitespace-nowrap transition-colors self-start sm:self-auto cursor-pointer"
        >
          Upgrade →
        </button>
      </div>
    </div>
  );
};

export default UploadLimitWarning;